import { IonLoading, IonToast } from "@ionic/react"
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router";
import { setInitialData } from "../../../store/formsubmitted";
import { RootState } from "../../../store/rootReducer";
import { findTemplatesAssignedToUser } from "../../../store/templateList/actions/findTemplatesAssignedToUser";
import { findDocuments } from "../../../store/userShow/actions/findDocuments";
import { initCreateAllAutomatticDocumentsStatus } from "../../../store/userTemplate";

export const AssignAndGenerateDocuments = () => {
    const { id }: { id: string } = useParams();
    const dispatch = useDispatch();
    const history = useHistory();
    const createStatus = useSelector((state: RootState) => state.userTemplate.createAllAutomatticDocumentsStatus);

    const handleFinishedAssign = async () => {
        await dispatch(findTemplatesAssignedToUser({ user: id }));
        dispatch(setInitialData());
        dispatch(initCreateAllAutomatticDocumentsStatus());
        await dispatch(findDocuments());
        history.replace(`/app/rrhh/usuarios/acuerdos/${id}`);
    }

    return (
        <>
            <IonLoading
                isOpen={createStatus === "pending"}
                message={`Creando acuerdos...`}
            />
            {createStatus === "succeeded" && (
                <IonToast
                    isOpen={true}
                    onDidDismiss={handleFinishedAssign}
                    message="Los acuerdos fueron creados satisfactoriamente"
                    position="bottom"
                    duration={3000}
                    color="success"
                />
            )}

            {createStatus === "failed" && (
                <IonToast
                    isOpen={true}
                    onDidDismiss={handleFinishedAssign}
                    message="Ocurrió un error al crear los acuerdos"
                    position="bottom"
                    duration={3000}
                    color="danger"
                />
            )}
        </>
    )
}